export default __webpack_public_path__ + "static/media/status-ready.0e13b8cd.svg";